import { iconMap } from './constants'

// Gets the appropriate icon name for a commodity type
export const getIcon = (
    commodityTypeId: number,
    defaultIcon: string = 'build_circle'
): string => {
    if (commodityTypeId in iconMap) {
        return iconMap[commodityTypeId]
    }

    return defaultIcon
}
